import { useQuery } from '@tanstack/react-query'
import EcommerceApi from '@/infrastructure/api/ecommerce'
import { ECommerceApiGetAvailableRestockLocationsRequest } from '@itsrever/rever-api'

export function useAvailableRestockLocations({
  variantIds,
  orderId,
  ecommerceId
}: ECommerceApiGetAvailableRestockLocationsRequest) {
  async function callRestockLocations() {
    if (!ecommerceId || !variantIds?.length || !orderId) return
    return EcommerceApi.getItemRestockLocations({
      ecommerceId,
      variantIds,
      orderId
    })
  }

  const itemRestockLocationsQuery = useQuery({
    queryKey: ['availableRestockLocations', ecommerceId, variantIds, orderId],
    queryFn: callRestockLocations,
    staleTime: 1000 * 60 * 15,
    enabled: !!ecommerceId && !!variantIds?.length
  })

  return {
    restockLocations: itemRestockLocationsQuery.data,
    loadingRestockLocations: itemRestockLocationsQuery.isLoading,
    status: itemRestockLocationsQuery.status
  }
}
